import { BlockSaveProps } from "@wordpress/blocks";
import React from "react";
import type { BlockAttributes } from "./block.json";
import { useBlockProps, InnerBlocks } from "@wordpress/block-editor";
import parse from "html-react-parser";

export default function CardSave({
  attributes,
}: BlockSaveProps<BlockAttributes>) {
  return (
    <div {...useBlockProps.save({ className: "d-flex" })}>
      <div className="slider-card bg-indigo">
        <div>
          <p className="copy-s mb-4">{parse(attributes.caption ?? "")}</p>
          <h2>{parse(attributes.heading ?? "")}</h2>
          <p className="copy-m pt-4">{parse(attributes.text ?? "")}</p>
        </div>

        <div className="pt-3 d-flex flex-wrap gap-3 get-button-count">
          <InnerBlocks.Content />
        </div>
      </div>
    </div>
  );
}
